import { Grid, makeStyles } from '@material-ui/core'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import CalcResultsListCardDetailComponent from './CalcResultsListCardDetailComponent'
import CircularProgress from '@material-ui/core/CircularProgress'
import TradeManagementTranslationText from 'src/views/trademanagement/shared/TradeManagementTranslationText'

const { CngGridItem } = components

const useStyles = makeStyles((theme) => ({
  sectionSummaryCards: {
    backgroundColor: theme.palette.background.white,
    paddingInline: '20px',
    paddingBlock: '0 20px',
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit'
  }
}))

const initialValues = Object.freeze({})

const FormBody = ({ searchCriteria, ...props }) => {
  const [hasMore, setHasMore] = useState(false)
  const [loading, setLoading] = useState(false)
  const [displayedProductsList, setDisplayedProductsList] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const loadAmount = 10
  const observer = useRef()
  const { fetchPageableRecords } = useServices()
  const classes = useStyles()


  // @purpose: To find, are there more pages of data to fetch and set page number & parcels
  useEffect(() => {
    setLoading(false)
    const temp = [...props.displayedProductsList]
    if (temp.length < loadAmount) {
      setHasMore(false)
    } else {
      setHasMore(true)
    }
    setPageNumber(0)

    setDisplayedProductsList(temp.flat())
  }, [props.displayedProductsList])


  return (
    <>
      <div
        className={`summary-list-items--container ${classes.sectionSummaryCards}`}
      >
        {displayedProductsList.map((product, idx) => (
          <div key={idx}>
            <CalcResultsListCardDetailComponent.FormBody
              product={product.calculationDetails}
              ftaName={product.fta}
              sequenceNo={idx}
              paramsData={props.paramsData}
              detailsData={props.detailsData}
              calculationResults={props.calculationResults}
              ftaActivityHistoryId={props.ftaActivityHistoryId}
              {...props}
            />
          </div>
        ))}
      </div>
    </>
  )
}

const CalcResultsListCardComponent = Object.freeze({
  FormBody: FormBody,
  initialValues: initialValues
})

export default CalcResultsListCardComponent
